import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { SortIcon, TableModule } from 'primeng/table';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { IntranetSeguridadService } from '../../../../core/services/intranet-seguridad.service';
import { LoadingService } from '../../../../core/services/loading.service';
import { AlertaService } from '../../../../core/services/alerta.service';

export type ReporteKey = 'solicitudes' | 'valoraciones' | 'usuarios' | 'vehiculos';
type Item = any;

@Component({ selector: 'app-reporte-usuarios-page', templateUrl: './usuarios.component.html', styleUrl: './usuarios.component.scss', imports: [CommonModule, FormsModule, ButtonModule, DialogModule, InputTextModule, TableModule, SortIcon] })
export class ReporteUsuariosComponent implements OnInit {
  @Input() reporteKey: ReporteKey = 'usuarios';
  key!: ReporteKey;
  titulo = '';
  columns: Array<{ key: string; label: string }> = [];
  items: Item[] = [];
  private todosLosItems: Item[] = [];
  filtro = { texto: '', estado: null as number | null, tipoSolicitud: '', fechaInicio: '', fechaFin: '' };
  busquedaRapida = '';
  filtroLocal = { fechaInicio: '', fechaFin: '', pais: '', estado: '', marca: '', modelo: '', tipo: '', visible: '', ordenar: '' };
  imagenes: Item[] = [];
  visibleImagenes = false;
  imagenSeleccionada = '';
  visibleImagenZoom = false;
  visibleDetalle = false;
  detalle: Item | null = null;
  visibleMapaSolicitud = false;
  mapaSolicitudUrl: SafeResourceUrl | null = null;
  tituloMapaSolicitud = '';
  ubicacionConductor: { latitud: number; longitud: number } | null = null;
  visibleAccionesSolicitud = false;
  solicitudAcciones: Item | null = null;
  usuarioClave: Item | null = null;
  visibleCambioClave = false;
  nuevaClave = '';

  constructor(private readonly seguridad: IntranetSeguridadService, private readonly loading: LoadingService, private readonly alerta: AlertaService, private readonly cdr: ChangeDetectorRef, private readonly sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    this.key = this.reporteKey;
    const config: Record<ReporteKey, [string, Array<{ key: string; label: string }>]> = {
      solicitudes: ['Solicitudes', [{ key: 'IdSolicitud', label: 'Solicitud' }, { key: 'TipoSolicitud', label: 'Tipo de solicitud' }, { key: 'Estado', label: 'Estado' }, { key: 'TipoVehiculo', label: 'Vehículo' }, { key: 'Cliente', label: 'Cliente' }, { key: 'Propietario', label: 'Propietario' }, { key: 'Conductor', label: 'Conductor' }, { key: 'EtapaViaje', label: 'Etapa' }, { key: 'FechaTrabajo', label: 'Fecha' }]],
      valoraciones: ['Valoraciones', [{ key: 'IdSolicitud', label: 'Solicitud' }, { key: 'UsuarioValorador', label: 'Valorador' }, { key: 'UsuarioValorado', label: 'Valorizado' }, { key: 'Valor', label: 'Puntaje' }, { key: 'Comentario', label: 'Comentario' }, { key: 'FechaCreacion', label: 'Fecha' }]],
      usuarios: ['Usuarios del aplicativo', [{ key: 'Pais', label: 'País' }, { key: 'Nombres', label: 'Nombres' }, { key: 'Apellidos', label: 'Apellidos' }, { key: 'CorreoElectronico', label: 'Correo' }, { key: 'Telefono', label: 'Teléfono' }, { key: 'Dni', label: 'DNI' }, { key: 'Saldo', label: 'Saldo' }, { key: 'Valoracion', label: 'Valoración' }, { key: 'FechaNacimiento', label: 'Nacimiento' }, { key: 'FechaCreacion', label: 'Registro' }, { key: 'Estado', label: 'Estado' }]],
      vehiculos: ['Vehículos', [{ key: 'IdVehiculo', label: 'ID' }, { key: 'TipoVehiculo', label: 'Tipo' }, { key: 'Marca', label: 'Marca' }, { key: 'Modelo', label: 'Modelo' }, { key: 'Placa', label: 'Placa' }, { key: 'Propietario', label: 'Propietario' }, { key: 'Visible', label: 'Visible' }]],
    };
    [this.titulo, this.columns] = config[this.key];
    this.cargar();
  }

  cargar(): void {
    this.loading.open('Cargando reporte...');
    const payload = this.key === 'solicitudes' ? this.filtro : {};
    this.seguridad.post<Item[]>(`reportes/${this.key}/listar`, payload).subscribe({
      next: (r) => { this.loading.close(); this.todosLosItems = r.isSuccess ? r.value ?? [] : []; this.aplicarBusqueda(); if (!r.isSuccess) this.alerta.openAlerta('Alerta', r.message, 'error'); this.cdr.detectChanges(); },
      error: (e) => { this.loading.close(); this.items = []; this.cdr.detectChanges(); this.alerta.openAlerta('Error', e?.message ?? 'No se pudo cargar el reporte', 'error'); },
    });
  }

  estadoSolicitud(estado: number): string { return ({ 1: 'Enviada', 2: 'Rechazada', 3: 'Enviada a conductor', 4: 'Aceptada', 5: 'Finalizada', 6: 'Cancelada', 7: 'Rechazada por conductor' } as Record<number, string>)[Number(estado)] ?? 'Sin estado'; }
  etapaViaje(etapa: number): string { return ({ 1: 'Yendo al tráiler', 2: 'Tráiler recogido', 3: 'Yendo a carga', 4: 'Viaje iniciado', 5: 'En ruta al destino', 6: 'Viaje completado' } as Record<number, string>)[Number(etapa)] ?? '-'; }
  ubicacionActual(item: Item): string { return item.LatitudActual && item.LongitudActual ? `${item.LatitudActual}, ${item.LongitudActual}` : '-'; }
  estadoUsuario(estado: number): string { return Number(estado) === 1 ? 'Activo' : 'Suspendido'; }
  esFechaTabla(campo: string): boolean { return ['FechaNacimiento', 'FechaCreacion', 'FechaTrabajo'].includes(campo); }
  formatearFecha(valor: unknown, incluirHora: boolean): string {
    if (!valor) return '-';
    const coincidencia = String(valor).match(/^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2})(?::(\d{2}))?)?/);
    if (!coincidencia) return String(valor);
    const [, anio, mes, dia, hora = '0', minuto = '0', segundo = '0'] = coincidencia;
    const fecha = new Date(Number(anio), Number(mes) - 1, Number(dia), Number(hora), Number(minuto), Number(segundo));
    return new Intl.DateTimeFormat('es-PE', incluirHora ? { dateStyle: 'medium', timeStyle: 'short' } : { dateStyle: 'medium' }).format(fecha);
  }

  aplicarBusqueda(): void {
    const termino = this.busquedaRapida.trim().toLocaleLowerCase();
    let resultado = !termino ? [...this.todosLosItems] : this.todosLosItems.filter((item) => JSON.stringify(item).toLocaleLowerCase().includes(termino));
    const f = this.filtroLocal;
    if (this.key === 'valoraciones' && (f.fechaInicio || f.fechaFin)) resultado = resultado.filter((i) => this.entreFechas(i.FechaCreacion, f.fechaInicio, f.fechaFin));
    if (this.key === 'usuarios') {
      if (f.pais) resultado = resultado.filter((i) => String(i.IdPais) === f.pais);
      if (f.estado) resultado = resultado.filter((i) => String(i.Estado) === f.estado);
      if (f.fechaInicio || f.fechaFin) resultado = resultado.filter((i) => this.entreFechas(i.FechaNacimiento, f.fechaInicio, f.fechaFin));
      if (f.ordenar) resultado.sort((a, b) => f.ordenar === 'saldo-desc' ? Number(b.Saldo) - Number(a.Saldo) : f.ordenar === 'saldo-asc' ? Number(a.Saldo) - Number(b.Saldo) : String(a.Nombres).localeCompare(String(b.Nombres)) * (f.ordenar === 'nombre-desc' ? -1 : 1));
    }
    if (this.key === 'vehiculos') {
      if (f.marca) resultado = resultado.filter((i) => String(i.Marca).toLowerCase().includes(f.marca.toLowerCase()));
      if (f.modelo) resultado = resultado.filter((i) => String(i.Modelo).toLowerCase().includes(f.modelo.toLowerCase()));
      if (f.tipo) resultado = resultado.filter((i) => i.TipoVehiculo === f.tipo);
      if (f.visible) resultado = resultado.filter((i) => String(i.Visible) === f.visible);
    }
    this.items = resultado;
  }

  private entreFechas(valor: string, inicio: string, fin: string): boolean { const fecha = String(valor ?? '').slice(0, 10); return (!inicio || fecha >= inicio) && (!fin || fecha <= fin); }
  paises(): Item[] { return [...new Map(this.todosLosItems.map((i) => [i.IdPais, i])).values()]; }
  tiposVehiculo(): string[] { return [...new Set(this.todosLosItems.map((i) => i.TipoVehiculo).filter(Boolean))]; }
  visibleVehiculo(item: Item): string { return Number(item.Visible) === 1 ? 'Sí' : 'No'; }
  esUsuarioActivo(item: Item): boolean { return Number(item.Estado) === 1; }
  esVehiculoVisible(item: Item): boolean { return Number(item.Visible) === 1; }
  claseEstadoSolicitud(estado: number): string { return [2, 6, 7].includes(Number(estado)) ? 'status-pill--danger' : Number(estado) === 5 ? 'status-pill--info' : 'status-pill--success'; }

  verRuta(item: Item): void { this.abrirMapaSolicitud(item, false); }

  solicitudEnCurso(item: Item): boolean { return Number(item.Estado) === 4; }
  verSeguimiento(item: Item): void {
    if (item.LatitudActual === null || item.LatitudActual === undefined || item.LongitudActual === null || item.LongitudActual === undefined) {
      this.alerta.openAlerta('Seguimiento', 'El conductor todavía no ha compartido una ubicación.', 'info');
      return;
    }
    this.abrirMapaSolicitud(item, true);
  }

  abrirAccionesSolicitud(item: Item): void { this.solicitudAcciones = item; this.visibleAccionesSolicitud = true; }
  ejecutarAccionSolicitud(accion: 'aceptar' | 'cancelar' | 'finalizar' | 'eliminar'): void {
    const solicitud = this.solicitudAcciones;
    if (!solicitud?.IdSolicitud) return;
    const etiquetas = { aceptar: 'aceptar', cancelar: 'cancelar', finalizar: 'finalizar', eliminar: 'eliminar' };
    this.alerta.openAlertaDesicion('Confirmar acción', `¿Deseas ${etiquetas[accion]} la solicitud #${solicitud.IdSolicitud}?`, accion === 'eliminar' || accion === 'cancelar' ? 'warn' : 'info', () => {
      this.loading.open('Actualizando solicitud...');
      this.seguridad.post('reportes/solicitudes/accion', { idSolicitud: solicitud.IdSolicitud, accion }).subscribe({
        next: (respuesta) => {
          this.loading.close();
          if (respuesta.isSuccess) {
            this.visibleAccionesSolicitud = false;
            this.alerta.openAlerta('Correcto', respuesta.message, 'success');
            this.cargar();
          } else this.alerta.openAlerta('Alerta', respuesta.message, 'error');
          this.cdr.detectChanges();
        },
        error: () => { this.loading.close(); this.alerta.openAlerta('Error', 'No se pudo actualizar la solicitud', 'error'); },
      });
    });
  }

  verImagenes(item: Item): void {
    this.loading.open('Cargando imágenes...');
    this.seguridad.post<Item[]>('reportes/vehiculos/imagenes', { idVehiculo: item.IdVehiculo }).subscribe({
      next: (r) => { this.loading.close(); this.imagenes = r.value ?? []; this.visibleImagenes = true; this.cdr.detectChanges(); },
      error: () => { this.loading.close(); this.alerta.openAlerta('Error', 'No se pudieron cargar las imágenes', 'error'); },
    });
  }

  verDetalle(item: Item): void {
    const endpoint = this.key === 'solicitudes' ? 'reportes/solicitudes/detalle' : this.key === 'vehiculos' ? 'reportes/vehiculos/detalle' : 'reportes/usuarios/detalle';
    const payload = this.key === 'solicitudes' ? { idSolicitud: item.IdSolicitud } : this.key === 'vehiculos' ? { idVehiculo: item.IdVehiculo } : { idUsuario: item.IdUsuario };
    this.loading.open('Cargando detalle...');
    this.seguridad.post<Item>(endpoint, payload).subscribe({
      next: (r) => { this.loading.close(); if (r.isSuccess) { this.detalle = r.value; this.visibleDetalle = true; this.cdr.detectChanges(); } else this.alerta.openAlerta('Alerta', r.message, 'error'); },
      error: () => { this.loading.close(); this.alerta.openAlerta('Error', 'No se pudo cargar el detalle', 'error'); },
    });
  }

  abrirImagen(url: string): void { this.imagenSeleccionada = url; this.visibleImagenZoom = true; this.cdr.detectChanges(); }
  abrirFotoPerfil(url: unknown): void { if (url) this.abrirImagen(String(url)); }
  abrirDocumento(url: unknown): void { if (url) window.open(String(url), '_blank', 'noopener'); }
  verMapaDetalle(): void {
    const latitud = this.detalle?.Latitud;
    const longitud = this.detalle?.Longitud;
    if (latitud !== null && latitud !== undefined && longitud !== null && longitud !== undefined) window.open(`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${latitud},${longitud}`)}`, '_blank', 'noopener');
  }
  esSolicitudTrailer(): boolean { return this.key === 'solicitudes' && String(this.detalle?.TipoSolicitud ?? '').toUpperCase() === 'TRAILER'; }
  esSolicitudMaquinaria(): boolean { return this.key === 'solicitudes' && !this.esSolicitudTrailer(); }
  verRutaDetalle(): void { if (this.detalle) this.abrirMapaSolicitud(this.detalle, false); }
  verMapaSolicitudDetalle(): void { if (this.detalle) this.abrirMapaSolicitud(this.detalle, false); }
  abrirCambioClave(item: Item): void { this.usuarioClave = item; this.nuevaClave = ''; this.visibleCambioClave = true; }
  guardarCambioClave(): void {
    if (!this.usuarioClave?.IdUsuario || this.nuevaClave.trim().length < 6) { this.alerta.openAlerta('Alerta', 'La nueva contraseña debe tener al menos 6 caracteres', 'warn'); return; }
    this.loading.open('Actualizando contraseña...');
    this.seguridad.post('reportes/usuarios/cambiar-clave', { idUsuario: this.usuarioClave.IdUsuario, clave: this.nuevaClave.trim() }).subscribe({
      next: (r) => { this.loading.close(); if (r.isSuccess) { this.visibleCambioClave = false; this.alerta.openAlerta('Correcto', r.message, 'success'); } else this.alerta.openAlerta('Alerta', r.message, 'error'); this.cdr.detectChanges(); },
      error: () => { this.loading.close(); this.alerta.openAlerta('Error', 'No se pudo actualizar la contraseña', 'error'); },
    });
  }

  cambiarEstadoUsuario(item: Item): void {
    const activar = !this.esUsuarioActivo(item);
    const accion = activar ? 'activar' : 'suspender';
    this.alerta.openAlertaDesicion('Confirmar acción', `¿Deseas ${accion} a ${item.Nombres} ${item.Apellidos}?`, activar ? 'info' : 'warn', () => {
      this.loading.open(`${activar ? 'Activando' : 'Suspendiendo'} usuario...`);
      this.seguridad.post('reportes/usuarios/actualizar-estado', { idUsuario: item.IdUsuario, estado: activar ? 1 : 0 }).subscribe({
        next: (respuesta) => {
          this.loading.close();
          if (respuesta.isSuccess) { this.alerta.openAlerta('Correcto', respuesta.message, 'success'); this.cargar(); }
          else this.alerta.openAlerta('Alerta', respuesta.message, 'error');
        },
        error: () => { this.loading.close(); this.alerta.openAlerta('Error', 'No se pudo actualizar el estado del usuario', 'error'); },
      });
    });
  }
  esDocumento(campo: string): boolean { return ['TarjetaPropiedad', 'TarjetaCirculacion', 'Soat', 'SeguroTrec'].includes(campo); }
  esFecha(campo: string): boolean { return campo.startsWith('Fecha') || campo.includes('Timestamp'); }
  etiquetaDetalle(campo: string): string {
    return ({ TipoVehiculo: 'Tipo de vehículo', Flota: 'Flota', PrecioHora: 'Precio por hora', CargaEstimada: 'Capacidad de carga estimada', AnioFabricacion: 'Año de fabricación', TarjetaPropiedad: 'Tarjeta de propiedad', TarjetaCirculacion: 'Tarjeta de circulación', SeguroTrec: 'Seguro TREC', FechaCreacion: 'Fecha de creación', FotoPerfil: 'Foto de perfil', CorreoElectronico: 'Correo electrónico', FechaNacimiento: 'Fecha de nacimiento', CantidadValoraciones: 'Cantidad de valoraciones', ValoracionPromedio: 'Valoración promedio', TipoSolicitud: 'Tipo de solicitud' } as Record<string, string>)[campo] ?? campo.replace(/([A-Z])/g, ' $1').trim();
  }
  valorDetalle(campo: string, valor: unknown): string {
    if (campo === 'Visible') return Number(valor) === 1 ? 'Sí' : 'No';
    if (campo === 'EtapaViaje') return this.etapaViaje(Number(valor));
    if (campo === 'Estado') return this.key === 'vehiculos' ? (Number(valor) === 1 ? 'Disponible' : 'No disponible') : (Number(valor) === 1 ? 'Activo' : 'Suspendido');
    if (this.esFecha(campo)) { const fecha = new Date(String(valor)); return Number.isNaN(fecha.getTime()) ? String(valor) : new Intl.DateTimeFormat('es-PE', { dateStyle: 'medium', timeStyle: 'short' }).format(fecha); }
    return String(valor);
  }
  detalleEntries(): Array<[string, unknown]> {
    const ocultos = new Set(['Activo', 'Latitud', 'Longitud', 'IdUsuarioCreacion']);
    if (this.key === 'solicitudes') {
      ['Estado', 'DireccionFin', 'LatitudInicio', 'LongitudInicio', 'LatitudFin', 'LongitudFin', 'LatitudActual', 'LongitudActual', 'TimestampUbicacion'].forEach((campo) => ocultos.add(campo));
      if (this.esSolicitudTrailer()) ocultos.add('DireccionInicio');
    }
    return Object.entries(this.detalle ?? {}).filter(([campo, valor]) => !campo.startsWith('Id') && !ocultos.has(campo) && valor !== null && valor !== '');
  }

  private abrirMapaSolicitud(item: Item, incluirConductor: boolean): void {
    const inicio = `${item.LatitudInicio},${item.LongitudInicio}`;
    const tieneDestino = item.LatitudFin !== null && item.LatitudFin !== undefined && item.LongitudFin !== null && item.LongitudFin !== undefined;
    const destino = tieneDestino ? `${item.LatitudFin},${item.LongitudFin}` : inicio;
    const conductor = incluirConductor ? `${item.LatitudActual},${item.LongitudActual}` : '';
    const parametros = new URLSearchParams({ saddr: inicio, daddr: destino, output: 'embed' });
    if (conductor) parametros.set('waypoints', conductor);
    this.mapaSolicitudUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`https://maps.google.com/maps?${parametros.toString()}`);
    this.tituloMapaSolicitud = incluirConductor ? 'Seguimiento del conductor' : tieneDestino ? 'Ruta del trabajo' : 'Ubicación del trabajo';
    this.ubicacionConductor = incluirConductor ? { latitud: Number(item.LatitudActual), longitud: Number(item.LongitudActual) } : null;
    this.visibleMapaSolicitud = true;
    this.cdr.detectChanges();
  }
}
